// id -> { type: 'table' | 'chart', baseId, index, data?: { title, columns, rows, dateRange } }
export const exportRegistry = new Map();

export function registerExport(id, meta) {
  if (id) exportRegistry.set(id, meta);
}
export function unregisterExport(id) {
  if (id) exportRegistry.delete(id);
}
export function getExportMeta(id) {
  return exportRegistry.get(id);
}
